import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Sections
import { LoginComponent } from './___COMPONENTS/__pages/login/login.component';
import { HomeComponent } from './___COMPONENTS/__pages/home/home.component';
import { WebappMenuComponent } from './___COMPONENTS/__pages/webapp-menu/webapp-menu.component';
import { MyProfileComponent } from './___COMPONENTS/__pages/my-profile/my-profile.component';
import { MyProjectComponent } from './___COMPONENTS/__pages/my-project/my-project.component';
import { SubAppComponent } from './___COMPONENTS/__apps/sub-app/sub-app.component';
import { AuthGuard } from './___LOGIC/__auth/auth.guard';
import { SettingsPageComponent } from './___COMPONENTS/__pages/settings-page/settings-page.component';
import { LoadingScreenComponent } from './___COMPONENTS/__common/loading-screen/loading-screen.component';
import { FaqsPageComponent } from './___COMPONENTS/__pages/faqs-page/faqs-page.component';
import { RedirectGuard } from './___LOGIC/__guards/redirect.guard';
import { RecoverPasswordComponent } from './___COMPONENTS/__pages/recover-password/recover-password.component';
import { RegisterPageComponent } from './___COMPONENTS/__pages/register-page/register-page.component';
import { ExploreComponent } from './___COMPONENTS/explore/explore.component';
import { DownloadZipComponent } from './___COMPONENTS/__files/download-zip/download-zip.component';
import { PricingPlansComponent } from './___COMPONENTS/pricing-plans/pricing-plans.component';
import { MaintenancePageComponent } from './___COMPONENTS/__pages/maintenance-page/maintenance-page.component';
import { MaintenanceGuard } from './___LOGIC/__guards/maintenance.guard';
import { ArticleComponent } from './___COMPONENTS/article/article.component';
import { MobileSliderFullComponent } from './___COMPONENTS/mobile-slider-full/mobile-slider-full.component';
import { WebappOnboardingComponent } from './___COMPONENTS/webapp-onboarding/webapp-onboarding.component';
import { ArticleLinkComponent } from './___COMPONENTS/article-link/article-link.component';
import { PdfViewerComponent } from './___COMPONENTS/__utilities/pdf-viewer/pdf-viewer.component';
import { PdfGuideSellComponent } from './___COMPONENTS/pdf-guide-sell/pdf-guide-sell.component';
import { PdfGuidePageComponent } from './___COMPONENTS/pdf-guide-page/pdf-guide-page.component';
import { RedirectPageComponent } from './___COMPONENTS/redirect-page/redirect-page.component';
import { VersionAvailableGuard } from './version-available.guard';


const routes: Routes = [

  // MAINTENANCE
  { path: 'maintenance', component: MaintenancePageComponent },
  // ROUTES
  { path: '', redirectTo: 'home', pathMatch: 'full' }, // Redirects '/' to '/home'
  { path: 'home', component: HomeComponent,canActivate: [MaintenanceGuard] },
  //LOGIN REGISTER FORGOT PASS
  { path: 'login', component: LoginComponent,canActivate: [MaintenanceGuard, VersionAvailableGuard] },
  { path: 'register', component: RegisterPageComponent,canActivate: [MaintenanceGuard,VersionAvailableGuard] },
  { path: 'recover-password/:token', component: RecoverPasswordComponent,canActivate: [MaintenanceGuard,VersionAvailableGuard] },
  { path: 'register/:token', component: RegisterPageComponent,canActivate: [MaintenanceGuard,VersionAvailableGuard] },
  { path: 'loading', component: LoadingScreenComponent,canActivate: [MaintenanceGuard] }, /* , canActivate: [RedirectGuard] */
  { path: 'explore', component: ExploreComponent,canActivate: [MaintenanceGuard,VersionAvailableGuard] }, /* , canActivate: [RedirectGuard] */
  /* { path: 'plans', component: PricingPlansComponent,canActivate: [AuthGuard,MaintenanceGuard] }, */ /* , canActivate: [RedirectGuard] */
  { path: 'welcome', component: WebappOnboardingComponent, canActivate: [RedirectGuard, MaintenanceGuard] },
  // NAV Sections
  { path: 'apps', component: WebappMenuComponent, canActivate: [RedirectGuard, MaintenanceGuard] }, /*  */
  { path: 'profile', component: MyProfileComponent, canActivate: [RedirectGuard, MaintenanceGuard] },
  { path: 'my-project', component: MyProjectComponent, canActivate: [RedirectGuard, MaintenanceGuard] },
  //Apps
  { path: 'sub-app/:id', component: SubAppComponent,canActivate: [MaintenanceGuard] },
  // Seguro médico
  { path: 'sub-app/:id/:token', component: SubAppComponent,canActivate: [MaintenanceGuard] },
  
  // MISC
  { path: 'download/:contractId', component: DownloadZipComponent,canActivate: [MaintenanceGuard] },
  { path: 'download-pdf/:contractId', component: DownloadZipComponent,canActivate: [MaintenanceGuard] },

  // REDIRECT FOR PRODUCT ACTIVATION
  { path: 'redirect/:token', component: RedirectPageComponent },

  // PDF guides
  { path: 'pdf-guide/:token', component: PdfGuidePageComponent,canActivate: [MaintenanceGuard] }, // GUIDE WAS PAID
  { path: 'pdf-guide', component: PdfGuidePageComponent,canActivate: [MaintenanceGuard] }, // JUST VIEW
  { path: 'pdf-guide-view/:id', component: PdfViewerComponent,canActivate: [MaintenanceGuard] },
  // PDF VIEWER
  { path: 'pdf-view/:id', component: PdfViewerComponent,canActivate: [MaintenanceGuard] },
  // General
  /* { path: 'faqs', component: FaqsPageComponent,canActivate: [MaintenanceGuard] }, */
  // Settings
  { path: 'settings', component: SettingsPageComponent,canActivate: [MaintenanceGuard] },

  // BLOG AND NEWS
  { path: 'article/:id', component: ArticleComponent },
  { path: 'art', component: ArticleLinkComponent },

  // Orders
  /*{ path: 'my-orders', component: MyOrdersComponent },  ,canActivate: [AuthGuard] */

  // ----------------
  { path: '**', redirectTo: '' }, // Catch-all redirect (optional)
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
